// extracted by mini-css-extract-plugin
module.exports = {"markdownList":"yc"};